module.exports = __webpack_public_path__ + "static/media/canYa.2335edc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/canYa.png
// module id = 1840
// module chunks = 146